import React from "react";
import moment from "moment";

import { OverflowTooltip } from "components";
import { Application, TableCellProp } from "types";

const ageInApplicationColumn = () => ({
	Header: "Age in Application",
	accessor: "ageInApplication",
	Cell: ({ row }: TableCellProp<Application>) => {
		const startDate = row.original?.created_at;
		const dateTime = moment
			.utc(startDate)
			.local()
			.format("MM/DD/YY h:mm A");
		const duration = moment.utc(startDate).local().fromNow(true);

		if (startDate)
			return (
				<div>
					<div className="hide-laptop">{dateTime}</div>
					<div className="cut-text-laptop">
						<OverflowTooltip onlyOnLaptop title={duration}>
							{duration}
						</OverflowTooltip>
					</div>
				</div>
			);
		else return "No data";
	},
});

export default ageInApplicationColumn;
